import React from 'react'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'

export type Props = {
  color?: string
  decoration?: 'underline' | 'none'
  dataTestId?: string
} & React.AnchorHTMLAttributes<HTMLAnchorElement>

export const A = React.forwardRef<HTMLAnchorElement, Props>(
  function Anchor(props, ref) {
    return (
      <a
        css={css`
          color: ${props.color || colors.link};
          text-decoration: ${props.decoration || 'underline'};
          &:hover {
            text-decoration: underline;
          }
        `}
        ref={ref}
        data-test-id={props.dataTestId}
        {...props}
      />
    )
  }
)
